define('blocks/reviews/reviews',['require','../../../cloud-web/js/radar'],function (require) {
  var radar = require('../../../cloud-web/js/radar');

  (function(){
    var $reviews = $('[data-block="reviews"]'),
        $slider = $('[data-carousel="reviews"]')
        $window = $(window),
        isScrollToReviews = false;
    ;

    if ($slider.length) {
      $slider.owlCarousel({
        autoWidth:true,
        responsiveClass:true,
        margin: 0,
        items: 1,
        smartSpeed: 700,
        responsive : {
          0: {
            nav: false,
            dots: true
          },
          1024: {
            nav: true,
            dots: false
          }
        }
      });
    }

    $window.scroll(function(){
      var offsetTop = $reviews.offset().top;

      if ($window.scrollTop() > offsetTop && !isScrollToReviews) {
        isScrollToReviews = true;

        radar.ga({
            category: 'review',
            action: 'show'
        });
      }
    });

  })();
});

